/**
 * pt-BR locale — Portuguese (Brazil)
 *
 * Extracted from all frontend source files (Issue #18 — i18n).
 * This is the source-of-truth locale; all other locales fall back to pt-BR
 * for any missing key.
 */
export const ptBR: Record<string, string> = {
  // ---------------------------------------------------------------------------
  // common — shared strings used across multiple pages/components
  // ---------------------------------------------------------------------------
  'common.loading': 'Carregando...',
  'common.checkSpam': 'Caso nao receba em alguns minutos, verifique a caixa de spam ou lixo eletronico.',
  'common.checkSpamThirdParty': 'Caso nao receba em alguns minutos, peca para verificar a caixa de spam ou lixo eletronico.',
  'common.close': 'Fechar',
  'common.cancel': 'Cancelar',
  'common.filter': 'Filtrar',
  'common.from': 'De',
  'common.to': 'Até',
  'common.all': 'Todos',
  'common.type': 'Tipo',
  'common.status': 'Status',
  'common.origin': 'Origem',
  'common.date': 'Data',
  'common.file': 'Arquivo',
  'common.value': 'Valor',
  'common.confidence': 'Confiança',
  'common.source': 'Origem',
  'common.field': 'Campo',
  'common.yes': 'Sim',
  'common.no': 'Não',
  'common.email': 'E-mail',
  'common.processing': 'Processando...',
  'common.error': 'Erro',
  'common.dash': '—',
  'common.filterPlaceholder': 'Filtrar...',
  'common.importId': 'Import ID',
  'common.corrected': 'corrigido',
  'common.errorPrefix': 'Erro: ',

  // Document type labels
  'common.doctype.nfe': 'NF-e',
  'common.doctype.nfse': 'NFS-e',
  'common.doctype.nfcom': 'NFCom',
  'common.doctype.email': 'Email',
  'common.doctype.zip': 'ZIP',
  'common.doctype.unknown': 'Desconhecido',

  // Legal document labels
  'common.legal.terms': 'Termos de Uso',
  'common.legal.privacy': 'Política de Privacidade',
  'common.legal.cookies': 'Política de Cookies',
  'common.legal.termsShort': 'Termos',
  'common.legal.privacyShort': 'Privacidade',
  'common.legal.cookiesShort': 'Cookies',
  'common.legal.custodia': 'Termo de Custódia',
  'common.legal.back': 'Voltar',

  // ---------------------------------------------------------------------------
  // app — App.tsx
  // ---------------------------------------------------------------------------
  'app.loading': 'Carregando...',
  // Issue #558: restore de sessao com retry — texto durante a verificacao,
  // falha transitoria persistente (token mantido) e botao de retry manual.
  'app.checking_session': 'Verificando sessão...',
  'app.session_check_failed': 'Não foi possível confirmar sua sessão agora — o servidor pode estar indisponível. Sua sessão foi mantida.',
  'app.try_again': 'Tentar novamente',

  // ---------------------------------------------------------------------------
  // home — Home.tsx
  // ---------------------------------------------------------------------------
  'home.title': 'Aura Nota',
  'home.subtitle': 'Ferramenta de captura e extração estruturada de notas fiscais brasileiras (NFS-e, NF-e e telecom).',
  'home.card.upload.title': 'Upload',
  'home.card.upload.desc': 'Receba PDFs, XMLs e imagens dos documentos.',
  'home.card.extraction.title': 'Extração',
  'home.card.extraction.desc': 'OCR, XML e LLM para ler campos automaticamente.',
  'home.card.review.title': 'Revisão',
  'home.card.review.desc': 'Interface humana para validar e corrigir dados.',
  'home.hero.title': 'Aura Nota — Captura e extração inteligente de notas fiscais',
  'home.hero.subtitle': 'Automatize a leitura de NFS-e, NFCom e recibos com IA. Extraia, valide e exporte campos fiscais em segundos.',
  'home.hero.cta.signup': 'Começar grátis',
  'home.hero.cta.pricing': 'Ver planos',
  'home.features.title': 'Recursos',
  'home.features.extraction.title': 'Extração Automática',
  'home.features.extraction.desc': 'Campos fiscais extraidos em segundos com IA',
  'home.features.lgpd.title': 'Conformidade LGPD',
  'home.features.lgpd.desc': 'Servidor na União Europeia com DPA, criptografia em trânsito e em repouso, DSAR e consentimento embutidos',
  'home.features.multilayout.title': 'Multi-layout',
  'home.features.multilayout.desc': 'NFS-e, NFCom, recibos e mais',
  'home.features.export.title': 'Exportação Estruturada',
  'home.features.export.desc': 'JSON, CSV e integracao com seu ERP',
  'home.pricing.teaser.title': 'Planos a partir de R$ 0',
  'home.pricing.teaser.desc': 'Comece grátis e evolua conforme sua demanda. Sem cartão de crédito.',
  'home.pricing.teaser.cta': 'Ver planos',
  'home.footer.login': 'Entrar',
  'home.footer.signup': 'Cadastro',
  'home.footer.pricing': 'Planos',
  'home.footer.dsar': 'DSAR',
  'home.footer.terms': 'Termos',
  'home.footer.privacy': 'Privacidade',
  // Issue #594: secoes da landing publica (visitante).
  'home.howItWorks.title': 'Como funciona',
  'home.howItWorks.step1.title': 'Envie suas notas',
  'home.howItWorks.step1.desc': 'Encaminhe os documentos para o seu e-mail dedicado de captura ou faça upload manual de PDFs, XMLs e imagens.',
  'home.howItWorks.step2.title': 'Extração automática',
  'home.howItWorks.step2.desc': 'XML é lido diretamente; PDFs e imagens passam por OCR e IA para extrair os campos fiscais.',
  'home.howItWorks.step3.title': 'Revise com segurança',
  'home.howItWorks.step3.desc': 'Campos com baixa confiança vão para a fila de revisão — cada correção fica registrada na trilha de auditoria.',
  'home.howItWorks.step4.title': 'Exporte para o seu ERP',
  'home.howItWorks.step4.desc': 'Baixe os dados estruturados em JSON ou CSV e envie ao seu sistema contábil ou ao seu contador.',
  'home.captures.title': 'O que capturamos',
  'home.captures.nfse.title': 'NFS-e',
  'home.captures.nfse.desc': 'Notas de serviço em PDF e XML dos mais diversos layouts e provedores municipais.',
  'home.captures.nfcom.title': 'NFCom / NFT (modelo 62)',
  'home.captures.nfcom.desc': 'Faturas de telecom com templates dedicados para as principais operadoras e um layout genérico.',
  'home.captures.nfe.title': 'NF-e e NFC-e',
  'home.captures.nfe.desc': 'XMLs de notas de mercadoria e cupons eletrônicos lidos diretamente, sem OCR.',
  'home.captures.others.title': 'Recibos, ZIP e e-mail',
  'home.captures.others.desc': 'Recibos e documentos digitalizados via OCR/IA, além de anexos em arquivos ZIP e e-mails (.eml).',
  'home.personas.title': 'Para quem é',
  'home.personas.company.title': 'Empresas',
  'home.personas.company.desc': 'O financeiro encaminha as notas para o e-mail de captura e exporta os dados prontos para o ERP ou para o contador.',
  'home.personas.accounting.title': 'Escritórios contábeis',
  'home.personas.accounting.desc': 'Plano Team com até 5 usuários, perfil de contador e documentos separados por cliente.',
  'home.personas.dev.title': 'Desenvolvedores',
  'home.personas.dev.desc': 'Integre a captura ao seu sistema pela API — disponível no plano Enterprise, sob consulta.',
  'home.diff.title': 'Diferenciais',
  'home.diff.dedup.title': 'Deduplicação automática',
  'home.diff.dedup.desc': 'A mesma nota não entra duas vezes: detectamos duplicatas pelo hash do arquivo e pela chave de acesso da NF.',
  'home.diff.audit.title': 'Trilha de auditoria',
  'home.diff.audit.desc': 'Cada ação sobre um documento fica registrada — quem fez, quando e por quê (LGPD).',
  'home.faq.title': 'Perguntas frequentes',
  'home.faq.q1': 'Quais tipos de documento o Aura Nota processa?',
  'home.faq.a1': 'NFS-e (PDF e XML de vários layouts municipais), faturas NFCom/NFT modelo 62, NF-e e NFC-e em XML, recibos e outros PDFs ou imagens via OCR. Arquivos ZIP e e-mails com anexos também são aceitos.',
  'home.faq.q2': 'Como funciona a captura por e-mail dedicado?',
  'home.faq.a2': 'Cada organização recebe um endereço de captura exclusivo. Basta encaminhar os e-mails com as notas em anexo — eles entram na fila de processamento automaticamente.',
  'home.faq.q3': 'Vocês guardam os arquivos originais?',
  'home.faq.a3': 'Não. O arquivo é processado e descartado; mantemos apenas os dados extraídos e os metadados, pelo prazo de retenção configurável da sua organização (padrão: 5 anos).',
  'home.faq.q4': 'Preciso de cartão de crédito para começar?',
  'home.faq.a4': 'Não. O plano Free inclui 10 documentos por mês e não pede cartão. Faça upgrade quando precisar de mais volume ou usuários.',
  'home.faq.q5': 'Posso cancelar quando quiser?',
  'home.faq.a5': 'Sim. O cancelamento entra em vigor no fim do período já pago — sem cobrança imediata e sem multa.',
  'home.faq.q6': 'Onde ficam hospedados os meus dados?',
  'home.faq.a6': 'Em servidor na União Europeia (França), sob contrato de tratamento de dados (DPA) e Cláusulas Contratuais Padrão, em conformidade com a LGPD. Os detalhes estão na Política de Privacidade.',
  'home.pricing.teaser.ctaSignup': 'Criar conta grátis',

  // ---------------------------------------------------------------------------
  // login — Login.tsx
  // ---------------------------------------------------------------------------
  'login.title': 'Entrar',
  'login.subtitle': 'Acesse sua conta do Aura Nota.',
  'login.email': 'E-mail',
  'login.password': 'Senha',
  'login.submit': 'Entrar',
  'login.submitting': 'Entrando...',
  'login.noAccount': 'Não tem conta?',
  'login.signupLink': 'Cadastre-se',
  'login.error.auth': 'Erro ao autenticar.',
  'session.expired': 'Sua sessão expirou. Por favor, faça login novamente.',
  'session.loginAgain': 'Entrar novamente',

  // ---------------------------------------------------------------------------
  // layout — Layout.tsx
  // ---------------------------------------------------------------------------
  'layout.brand': 'Aura Nota',
  'layout.nav.home': 'Início',
  'layout.nav.upload': 'Upload',
  'layout.nav.documents': 'Documentos',
  // Issue #549: 'Billing' -> 'Cobrança' (pt-BR nao usa termo em ingles).
  'layout.nav.billing': 'Cobrança',
  'layout.nav.quota': 'Cota',
  'layout.nav.subscription': 'Assinatura',
  // Issue #549: 'Minha conta' unificado (era 'Minha Conta'/'Conta' em
  // lugares diferentes; account.title ja usava 'Minha conta').
  'layout.nav.myAccount': 'Minha conta',
  'layout.nav.team': 'Equipe',
  'layout.nav.admin': 'Admin',
  // Issue #549: item de nav 'Clientes' movido para i18n.
  'layout.nav.clients': 'Clientes',
  // Issue #550: grupo de nav "Gestao" (ex-"Plataforma") — Configuracoes,
  // Auditoria LGPD, Equipe, Clientes e Municipios.
  'layout.nav.gestao': 'Gestão',
  'layout.nav.audit': 'Auditoria LGPD',
  // Issue #549: opcao "sem filtro" do seletor de cliente ativo (contador).
  'layout.clientSelector.all': 'Todos os clientes',
  'layout.account': 'Minha conta',
  'layout.logout': 'Sair',
  'layout.login': 'Entrar',
  'layout.footer.terms': 'Termos de Uso',
  'layout.footer.privacy': 'Política de Privacidade',
  'layout.footer.cookies': 'Política de Cookies',
  'layout.footer.tagline': 'Aura Nota · captura e extração de notas fiscais',

  // ---------------------------------------------------------------------------
  // consent — ConsentGate.tsx
  // ---------------------------------------------------------------------------
  'consent.title': 'Consentimento LGPD',
  'consent.intro': 'Para continuar utilizando o Aura Nota, é necessário aceitar a versão vigente ({version}) dos seguintes documentos legais:',
  'consent.acceptLabel': 'Li e aceito os Termos de Uso, a Política de Privacidade e a Política de Cookies.',
  'consent.submit': 'Aceitar e continuar',
  'consent.submitting': 'Registrando...',
  'consent.error.check': 'Erro ao verificar consentimento.',
  'consent.error.mustAccept': 'É necessário aceitar os documentos legais para continuar.',
  'consent.error.register': 'Erro ao registrar consentimento.',

  // ---------------------------------------------------------------------------
  // errorBoundary — ErrorBoundary.tsx
  // ---------------------------------------------------------------------------
  'errorBoundary.title': 'Algo deu errado',
  'errorBoundary.message': 'Ocorreu um erro inesperado. Tente recarregar a página.',
  'errorBoundary.reload': 'Recarregar',

  // ---------------------------------------------------------------------------
  // account — Account.tsx
  // ---------------------------------------------------------------------------
  'account.title': 'Minha conta',
  'account.emailLabel': 'E-mail:',
  'account.statusLabel': 'Status:',
  'account.statusActive': 'Ativo',
  'account.statusInactive': 'Inativo',
  'account.historyTitle': 'Histórico de consentimento',
  'account.legalDocsIntro': 'Documentos legais vigentes: ',
  'account.loading': 'Carregando...',
  'account.error.load': 'Erro ao carregar histórico.',
  'account.empty': 'Nenhum consentimento registrado.',
  'account.col.document': 'Documento',
  'account.col.version': 'Versão',
  'account.col.accepted': 'Aceito',
  'account.col.date': 'Data',
  'account.col.ip': 'IP',
  // Edicao de dados pessoais ("Meus dados") + troca de senha.
  'account.profile.title': 'Meus dados',
  'account.profile.name': 'Nome',
  'account.profile.namePlaceholder': 'Seu nome completo',
  'account.profile.nameRequired': 'Informe um nome válido.',
  'account.profile.language': 'Idioma',
  'account.profile.email': 'E-mail',
  'account.profile.emailNote': 'Para alterar o e-mail, contate o suporte/administrador.',
  'account.profile.save': 'Salvar',
  'account.profile.saving': 'Salvando...',
  'account.profile.saved': 'Dados atualizados com sucesso.',
  'account.profile.error': 'Erro ao salvar dados.',
  'account.password.title': 'Alterar senha',
  'account.password.current': 'Senha atual',
  'account.password.new': 'Nova senha',
  'account.password.confirm': 'Confirmar nova senha',
  'account.password.hint': 'Mínimo 8 caracteres, com pelo menos 1 letra e 1 número.',
  'account.password.submit': 'Alterar senha',
  'account.password.submitting': 'Alterando...',
  'account.password.success': 'Senha alterada com sucesso.',
  'account.password.error': 'Erro ao alterar senha.',
  'account.password.mismatch': 'A confirmação não confere com a nova senha.',
  'account.password.tooShort': 'A nova senha deve ter pelo menos 8 caracteres.',

  // ---------------------------------------------------------------------------
  // audit — Audit.tsx
  // ---------------------------------------------------------------------------
  'audit.title': 'Auditoria LGPD',
  'audit.subtitle': 'Log de eventos de processamento, acesso e consentimento.',
  'audit.exportCsv': 'Exportar CSV',
  'audit.exportJson': 'Exportar JSON',
  // Issue #550: export assincrono (fetch autenticado + blob download).
  'audit.exporting': 'Exportando...',
  'audit.error.export': 'Erro ao exportar auditoria.',
  'audit.compliance.title': 'Conformidade LGPD',
  'audit.compliance.pii': 'PII anonimizado: nomes de arquivo e hashes são armazenados sem dados pessoais diretos',
  'audit.compliance.retention': 'Retenção: logs de auditoria são imutáveis e mantidos conforme política de retenção',
  'audit.compliance.dsar': 'DSAR: direitos do titular (acesso, exclusao, portabilidade) disponíveis via API',
  'audit.filter.eventType': 'Tipo de evento',
  'audit.filter.from': 'De',
  'audit.filter.to': 'Até',
  'audit.filter.all': 'Todos',
  'audit.loading': 'Carregando...',
  'audit.error.load': 'Erro ao carregar auditoria.',
  'audit.empty': 'Nenhum evento de auditoria encontrado.',
  'audit.eventCount': '{count} eventos',
  'audit.col.date': 'Data',
  'audit.col.event': 'Evento',
  'audit.col.resource': 'Recurso',
  'audit.col.details': 'Detalhes',
  'audit.col.user': 'Usuário',
  // Issue #550: grupos do filtro de acoes (optgroups) — acoes realmente
  // gravadas no audit_log pelo backend (ver AUDIT_ACTION_GROUPS).
  'audit.group.documents': 'Documentos',
  'audit.group.sefaz': 'Fiscal / SEFAZ',
  'audit.group.certificates': 'Certificados',
  'audit.group.org': 'Organização e usuários',
  'audit.group.finance': 'Conciliação e RPA',
  'audit.group.catalogo': 'Catálogo',
  'audit.group.other': 'Outros',
  // Action labels (filtro + coluna Evento da tabela)
  'audit.action.document_upload': 'Upload de documento',
  'audit.action.document_upload_api_v1': 'Upload via API',
  'audit.action.document_email_upload': 'Upload por e-mail',
  'audit.action.document_upload_duplicate': 'Upload duplicado',
  'audit.action.document_processed': 'Documento processado',
  'audit.action.document_field_correction': 'Correção de campo',
  'audit.action.document_substituted': 'Documento substituído',
  'audit.action.document_soft_deleted': 'Exclusão (lixeira)',
  'audit.action.document_deleted': 'Exclusão definitiva',
  'audit.action.document_restored': 'Documento restaurado',
  'audit.action.document_purged': 'Eliminação por retenção',
  'audit.action.sefaz_search': 'Consulta SEFAZ',
  'audit.action.sefaz_batch_search': 'Consulta SEFAZ em lote',
  'audit.action.sefaz_batch_upload': 'Upload de lote SEFAZ',
  'audit.action.sefaz_batch_export': 'Exportação de lote SEFAZ',
  'audit.action.nfse_validate': 'Validação NFS-e',
  'audit.action.cert_upload': 'Upload de certificado',
  'audit.action.cert_view': 'Consulta de certificado',
  'audit.action.cert_rotate': 'Rotação de certificado',
  'audit.action.cert_delete': 'Exclusão de certificado',
  'audit.action.cert_use': 'Uso de certificado',
  'audit.action.cert_session_open': 'Abertura de sessão de certificado',
  'audit.action.cert_consent_grant': 'Consentimento de certificado',
  'audit.action.member_activate': 'Membro reativado',
  'audit.action.member_deactivate': 'Membro desativado',
  'audit.action.member_password_reset': 'Senha de membro redefinida',
  'audit.action.org_switch': 'Troca de organização',
  'audit.action.org_settings_update': 'Configurações atualizadas',
  'audit.action.impersonation_start': 'Início de impersonação',
  'audit.action.impersonation_exit': 'Fim de impersonação',
  'audit.action.api_key_created': 'Chave de API criada',
  'audit.action.api_key_revoked': 'Chave de API revogada',
  'audit.action.conciliacao_mapping': 'Mapeamento de conciliação',
  'audit.action.conciliacao_suggest': 'Sugestão de conciliação',
  'audit.action.conciliacao_review': 'Revisão de conciliação',
  'audit.action.conciliacao_export': 'Exportação de conciliação',
  'audit.action.rpa_credential_save': 'Credencial RPA salva',
  'audit.action.rpa_credential_delete': 'Credencial RPA removida',
  'audit.action.rpa_run': 'Execução RPA',
  'audit.action.rpa_operator_notify': 'Notificação a operador RPA',
  'audit.action.catalogo_sugestao_create': 'Sugestão de catálogo criada',
  'audit.action.catalogo_sugestao_review': 'Sugestão de catálogo revisada',
  'audit.action.catalogo_municipio_write': 'Catálogo de municípios atualizado',
  'audit.action.catalogo_import': 'Importação de catálogo',
  'audit.action.onboarding_step': 'Passo de onboarding',
  'audit.action.onboarding_completed': 'Onboarding concluído',

  // ---------------------------------------------------------------------------
  // documents — Documents.tsx
  // ---------------------------------------------------------------------------
  'documents.title': 'Documentos',
  'documents.view.grid': 'Grid',
  'documents.view.cards': 'Cards',
  // Issue #549: banners do cliente ativo do contador (antes hardcoded).
  'documents.clientBanner.active': 'Mostrando documentos do cliente: {name}',
  'documents.clientBanner.all': 'Mostrando todos os clientes. Selecione um cliente no seletor do topo para filtrar.',
  'documents.export.csv': 'Exportar CSV',
  'documents.export.excel': 'Exportar Excel',
  'documents.filter.type': 'Tipo',
  'documents.filter.status': 'Status',
  'documents.filter.all': 'Todos',
  'documents.filter.from': 'De',
  'documents.filter.to': 'Até',
  'documents.filter.importId': 'Import ID',
  'documents.filter.importIdPlaceholder': 'ex: 20260819-001',
  'documents.filter.button': 'Filtrar',
  'documents.loading': 'Carregando...',
  'documents.loadingDetails': 'Carregando detalhes...',
  'documents.empty': 'Nenhum documento encontrado.',
  'documents.error.load': 'Erro ao carregar documentos.',
  'documents.error.loadDetail': 'Erro ao carregar detalhe.',
  'documents.error.saveField': 'Erro ao salvar campo.',
  'documents.error.export': 'Erro ao exportar.',

  // Status filter options
  'documents.status.concluido': 'Concluído',
  'documents.status.revisao': 'Revisão',
  'documents.status.erro': 'Erro',
  'documents.status.recebido': 'Recebido',

  // Fiscal column headers (grid)
  'documents.col.numero': 'Número',
  'documents.col.serie': 'Série',
  'documents.col.prestadorCnpj': 'Prestador CNPJ',
  'documents.col.prestadorCnpjEmitente': 'CNPJ do Emitente',
  'documents.col.prestador': 'Prestador',
  'documents.col.tomadorCnpj': 'Tomador CNPJ',
  'documents.col.tomadorCnpjDestinatario': 'CNPJ do Destinatário',
  'documents.col.tomador': 'Tomador',
  'documents.col.valorTotal': 'Valor Total',
  'documents.col.valorServico': 'Valor Serviço',
  'documents.col.dataEmissao': 'Data Emissão',
  'documents.col.municipio': 'Município',
  'documents.col.codVerificacao': 'Cod. Verificação',
  'documents.col.descricao': 'Descrição',
  'documents.col.imPrestador': 'IM Prestador',
  'documents.col.docType': 'Tipo de Documento',
  'documents.col.importId': 'Import ID',
  'documents.col.origin': 'Origem',

  // Cards view headers
  'documents.cards.importId': 'Import ID',
  'documents.cards.file': 'Arquivo',
  'documents.cards.type': 'Tipo',
  'documents.cards.status': 'Status',
  'documents.cards.fields': 'Campos',
  'documents.cards.confidence': 'Confiança',
  'documents.cards.children': 'Filhos',
  'documents.cards.date': 'Enviado em',
  'documents.cards.processedAt': 'Processado em',

  // Detail panel
  'documents.detail.close': 'Fechar',
  'documents.detail.downloading': 'Baixando...',
  'documents.detail.downloadJson': 'Baixar JSON',
  'documents.detail.downloadXml': 'Baixar XML',
  'documents.detail.downloadPdf': 'Baixar PDF',
  'documents.detail.downloadFields': 'Baixar campos (CSV)',
  'documents.detail.type': 'Tipo',
  'documents.detail.origin': 'Origem',
  'documents.detail.status': 'Status',
  'documents.detail.avgConfidence': 'Confiança média',
  'documents.detail.processedAt': 'Processado em',
  'documents.detail.processing': 'Processamento',
  'documents.detail.processingStartedAt': 'Iniciado em',
  'documents.detail.importId': 'ID de importação',
  'documents.detail.processingSteps': 'Etapas de processamento',
  'documents.detail.needsReview': 'Requer revisão: {reason}',
  'documents.detail.reviewReasonDefault': 'Motivo não especificado',
  'documents.detail.error': 'Erro: {error}',
  'documents.detail.extractedFields': 'Campos extraídos',
  'documents.detail.col.field': 'Campo',
  'documents.detail.col.value': 'Valor',
  'documents.detail.col.confidence': 'Confiança',
  'documents.detail.col.origin': 'Origem',
  'documents.detail.col.raw': 'Raw',
  'documents.detail.metadata': 'Metadados',
  'documents.detail.children': 'Documentos filhos ({count})',
  'documents.detail.childError': 'erro',
  'documents.detail.processingLog': 'Log de auditoria do processamento',

  // Editable cell tooltip
  'documents.cell.tooltip': '{field} — confiança {conf}% (duplo-clique para editar)',

  // Provenance modal
  'documents.provenance.title': 'Cadeia de Origem',
  'documents.provenance.close': 'Fechar',
  'documents.provenance.noChain': 'Sem container_chain (arquivo terminal direto).',
  'documents.delete': 'Excluir',
  'documents.deleteConfirm': 'Tem certeza que deseja mover este documento para a lixeira? Você poderá recuperá-lo por 30 dias.',
  'documents.trash': 'Lixeira',
  'documents.restore': 'Restaurar',
  'documents.daysUntilPurge': 'Dias até exclusão permanente',
  'documents.timeRemaining': 'Tempo restante: {days} dias até exclusão permanente',
  'documents.trashEmpty': 'A lixeira esta vazia.',
  'documents.trashDeletedAt': 'Deletado em',
  'documents.actions': 'Ações',
  'documents.error.delete': 'Erro ao mover documento para a lixeira.',
  'documents.error.restore': 'Erro ao restaurar documento.',

  // Batch selection (Feature 2)
  'documents.batch.selectedCount': '{count} selecionados',
  'documents.batch.selectAll': 'Selecionar todos',
  'documents.batch.deleteTitle': 'Excluir documentos',
  'documents.batch.deleteConfirm': 'Tem certeza que deseja excluir {count} documento(s)? Eles serão movidos para a lixeira e poderão ser recuperados por 30 dias.',
  'documents.batch.deletePartialError': 'Erro ao excluir {failed} de {total} documento(s).',

  // ---------------------------------------------------------------------------
  // upload — Upload.tsx
  // ---------------------------------------------------------------------------
  'upload.title': 'Upload de Documentos',
  'upload.subtitle': 'Envie PDFs, XMLs, emails (.eml/.msg), ZIPs, HTML ou imagens para extração automática de campos fiscais.',
  'upload.dropzone.text': 'Arraste arquivos aqui ou clique para selecionar',
  'upload.dropzone.formats': 'Formatos: {formats} — Max 25 MB',
  'upload.process': 'Processar ({count} pendentes)',
  'upload.processing': 'Processando...',
  'upload.clear': 'Limpar',
  'upload.summary': '{done} concluídos, {errors} erros, {pending} pendentes',
  'upload.filesTitle': 'Arquivos enviados',
  'upload.viewResult': 'Ver resultado',
  'upload.remove': 'Remover',
  'upload.result.type': 'Tipo: {type}',
  'upload.result.origin': 'Origem: {origin}',
  'upload.result.fields': 'Campos: {count}',
  'upload.result.errors': 'Erros: {count}',
  'upload.result.duplicate': 'Duplicata',
  'upload.error.batchNotFound': 'Resultado não encontrado no batch.',
  'upload.error.cancelledDuplicate': 'Cancelado (duplicata não processada)',
  'upload.error.timeout': 'Tempo esgotado aguardando processamento.',
  // Issue #279: Modo batch para uploads de 3+ arquivos.
  'upload.batch.submitted': 'Lote enviado. Você será avisado ao concluir.',
  'upload.batch.inProgress': 'Lote em processamento: {done}/{total} concluídos',
  'upload.batch.complete': 'Lote concluído: {success} sucessos, {errors} erros',
  'upload.batch.blocked': 'Aguarde o lote atual concluir',
  'upload.batch.networkError': 'O lote pode estar sendo processado no servidor. Verifique a lista de documentos antes de re-enviar.',
  'upload.batch.checkStatus': 'Verificar status',

  // Status badge labels
  'upload.status.pending': 'Pendente',
  'upload.status.uploading': 'Enviando...',
  'upload.status.processing': 'Processando...',
  'upload.status.done': 'Concluído',
  'upload.status.error': 'Erro',

  // Result panel
  'upload.result.title': 'Resultado da extração',
  'upload.result.close': 'Fechar',
  'upload.result.file': 'Arquivo',
  'upload.result.typeLabel': 'Tipo',
  'upload.result.originLabel': 'Origem',
  'upload.result.time': 'Tempo',
  'upload.result.needsReview': 'Requer revisão: {reason}',
  'upload.result.reviewReasonDefault': 'Motivo não especificado',
  'upload.result.error': 'Erro: {error}',
  'upload.result.extractedFields': 'Campos extraídos',
  'upload.result.col.field': 'Campo',
  'upload.result.col.value': 'Valor',
  'upload.result.col.confidence': 'Confiança',
  'upload.result.col.origin': 'Origem',
  'upload.result.metadata': 'Metadados',
  'upload.result.children': 'Documentos filhos ({count})',
  'upload.result.childError': 'erro',

  // Duplicate modal (single file)
  'upload.duplicate.title': 'NF Duplicada Detectada',
  'upload.duplicate.intro': 'Esta NF já foi processada anteriormente.',
  'upload.duplicate.type.file': 'Arquivo idêntico',
  'upload.duplicate.type.data': 'Mesma NF (dados)',
  'upload.duplicate.importId': 'Import ID',
  'upload.duplicate.type': 'Tipo',
  'upload.duplicate.file': 'Arquivo',
  'upload.duplicate.processedAt': 'Processada em',
  'upload.duplicate.whatToDo': 'O que você deseja fazer?',
  'upload.duplicate.replace': 'Substituir',
  'upload.duplicate.replaceDesc': 'remove o registro anterior e cria um novo',
  'upload.duplicate.archive': 'Arquivar',
  'upload.duplicate.archiveDesc': 'mantém o registro anterior arquivado e cria um novo',
  'upload.duplicate.duplicate': 'Duplicar',
  'upload.duplicate.duplicateDesc': 'cria um novo registro sem alterar o anterior',
  'upload.duplicate.cancel': 'Cancelar',
  'upload.duplicate.cancelDesc': 'não processar',
  'upload.duplicate.processing': 'Processando...',

  // Batch duplicate modal
  'upload.batchDuplicate.title': '{count} arquivo(s) duplicado(s) encontrado(s)',
  'upload.batchDuplicate.intro': 'Os arquivos abaixo ja foram processados anteriormente. Escolha uma acao para cada um. Arquivos nao-duplicados serao processados normalmente.',
  'upload.batchDuplicate.type.file': 'Arquivo idêntico',
  'upload.batchDuplicate.type.data': 'Mesma NF (dados)',
  'upload.batchDuplicate.existingImportId': 'Import ID existente',
  'upload.batchDuplicate.existingFile': 'Arquivo existente',
  'upload.batchDuplicate.processedAt': 'Processado em',
  'upload.batchDuplicate.replace': 'Substituir',
  'upload.batchDuplicate.replaceDesc': 'remove o anterior e cria novo',
  'upload.batchDuplicate.archive': 'Arquivar',
  'upload.batchDuplicate.archiveDesc': 'arquiva o anterior e cria novo',
  'upload.batchDuplicate.duplicate': 'Duplicar',
  'upload.batchDuplicate.duplicateDesc': 'cria novo sem alterar o anterior',
  'upload.batchDuplicate.remove': 'Remover',
  'upload.batchDuplicate.removeDesc': 'deleta o registro anterior (admin)',
  'upload.batchDuplicate.cancel': 'Cancelar',
  'upload.batchDuplicate.cancelDesc': 'não processar',
  'upload.batchDuplicate.cancelAll': 'Cancelar tudo',
  'upload.batchDuplicate.confirm': 'Confirmar decisões',
  'upload.batchDuplicate.processing': 'Processando...',

  // Notifications (Issue #281)
  'notifications.title': 'Notificações',
  'notifications.empty': 'Nenhuma notificação',
  'notifications.markAllRead': 'Marcar todas como lidas',
  'notifications.batchComplete': 'Lote concluído',
  'notifications.justNow': 'agora mesmo',
  'notifications.minutesAgo': 'há {n} min',
  'notifications.hoursAgo': 'há {n} h',
  'notifications.daysAgo': 'há {n} d',
  // Sprint 7: Billing / Pricing / Signup

  'layout.nav.pricing': 'Planos',
  'pricing.title': 'Escolha o plano ideal para você',
  'pricing.subtitle': 'Comece grátis e evolua conforme sua demanda. Sem cartão de crédito.',
  'pricing.unlimited': 'Sob consulta',
  'pricing.free': 'Grátis',
  'pricing.month': 'mês',
  'pricing.unlimitedDocs': 'Documentos ilimitados',
  'pricing.docsPerMonth': '{count} documentos/mês',
  'pricing.popular': 'Mais popular',
  'pricing.feat.upload': 'Upload de documentos',
  'pricing.feat.exportCsv': 'Exportar CSV',
  'pricing.feat.multiUser': 'Múltiplos usuários',
  'pricing.feat.audit': 'Auditoria',
  'pricing.feat.apiAccess': 'Acesso à API',
  'pricing.feat.prioritySupport': 'Suporte prioritário',
  'pricing.ctaFree': 'Começar grátis',
  'pricing.ctaPaid': 'Assinar',
  'pricing.processing': 'Processando...',
  'pricing.pixTitle': 'Pague via PIX',
  'pricing.pixInstructions': 'Escaneie o QR code abaixo com seu banco para pagar a assinatura.',
  'pricing.goToBilling': 'Ir para Billing',
  // Issue #544: cupom de desconto no checkout.
  'pricing.coupon.label': 'Tem um cupom?',
  'pricing.coupon.placeholder': 'Digite o código do cupom',
  'pricing.coupon.apply': 'Aplicar',
  'pricing.coupon.applying': 'Aplicando...',
  'pricing.coupon.remove': 'Remover',
  'pricing.coupon.applied': 'Cupom aplicado!',
  // Security review #544: 'invalid' e a resposta anti-enumeracao do
  // /validate (inexistente ou inativo — nao revela se o codigo existe).
  'pricing.coupon.error.invalid': 'Cupom inválido.',
  'pricing.coupon.error.not_found': 'Cupom não encontrado.',
  'pricing.coupon.error.inactive': 'Cupom inativo.',
  'pricing.coupon.error.expired': 'Cupom expirado.',
  'pricing.coupon.error.ineligible_plan': 'Cupom não elegível para este plano.',
  'pricing.coupon.error.exhausted': 'Cupom esgotado (limite de usos atingido).',
  'pricing.coupon.error.org_exhausted': 'Cupom já utilizado por esta organização.',
  'pricing.coupon.error.invalid_plan': 'Plano inválido para aplicação de cupom.',
  'pricing.courtesyTitle': 'Plano ativado!',
  'pricing.courtesyBody': 'Seu cupom cobriu 100% do valor — nenhum pagamento é necessário.',
  // Issue #593: planos Single/Team/Enterprise (contrato #592) + tabela
  // comparativa na mesma pagina.
  'pricing.ctaEnterprise': 'Falar com vendas',
  'pricing.enterpriseMailSubject': 'Aura Nota — Plano Enterprise',
  'pricing.users.one': '1 usuário',
  'pricing.users.upTo': 'Até {count} usuários',
  'pricing.users.unlimited': 'Usuários ilimitados',
  'pricing.feat.exportJson': 'Exportar JSON',
  'pricing.feat.emailCapture': 'Captura por e-mail dedicado',
  'pricing.feat.accountant': 'Usuário contador',
  'pricing.feat.onboarding': 'Onboarding assistido',
  'comparison.title': 'Comparação de planos',
  'comparison.subtitle': 'Todos os recursos, lado a lado.',
  'comparison.feature': 'Recurso',
  'comparison.unlimited': 'Ilimitado',
  'comparison.row.docs': 'Documentos por mês',
  'comparison.row.users': 'Usuários incluídos',
  'comparison.row.accountant': 'Usuário contador',
  'comparison.row.emailUpload': 'Captura por e-mail dedicado e upload manual',
  'comparison.row.exportJson': 'Exportação JSON',
  'comparison.row.exportCsv': 'Exportação CSV',
  'comparison.row.multiUser': 'Multi-usuário (equipe)',
  'comparison.row.audit': 'Trilha de auditoria (LGPD)',
  'comparison.row.apiAccess': 'Acesso à API',
  'comparison.row.prioritySupport': 'Suporte prioritário',
  'comparison.row.onboarding': 'Onboarding assistido',
  'signup.title': 'Criar conta',
  'signup.subtitle': 'Comece a usar o Aura Nota gratuitamente.',
  'signup.name': 'Nome',
  'signup.company': 'Empresa',
  'signup.email': 'E-mail',
  'signup.password': 'Senha',
  'signup.passwordHint': 'Mínimo 8 caracteres, 1 letra e 1 número.',
  'signup.submit': 'Criar conta',
  'signup.submitting': 'Criando...',
  'signup.error': 'Não foi possível criar a conta.',
  'signup.haveAccount': 'Já tem conta?',
  'signup.loginLink': 'Entrar',
  'signup.successTitle': 'Conta criada!',
  'signup.successBody': 'Verifique seu e-mail para ativar a conta. Após a ativação, você poderá fazer login.',
  'signup.goLogin': 'Ir para login',
  'billing.title': 'Billing',
  'billing.currentPlan': 'Plano atual',
  'billing.planLabel': 'Plano',
  'billing.statusLabel': 'Status',
  'billing.status.active': 'Ativo',
  'billing.status.pending_payment': 'Pagamento pendente',
  'billing.status.suspended': 'Suspenso',
  'billing.status.cancelled': 'Cancelado',
  'billing.renewsOn': 'Renova em',
  'billing.paymentMethod': 'Método de pagamento',
  'billing.usage': 'Uso este mês',
  'billing.used': '{used} de {limit} documentos',
  'billing.remaining': '{count} restantes',
  'billing.unlimited': 'Ilimitado',
  'billing.resetsOn': 'Reseta em {date}',
  'billing.pendingPayment': 'Pagamento pendente',
  'billing.invoiceAmount': 'R$ {amount}',
  'billing.dueDate': 'Vencimento: {date}',
  'billing.pixTitle': 'Pague via PIX',
  'billing.pixInstructions': 'Escaneie o QR code com seu banco. Após o pagamento, o admin confirmará e seu plano será ativado.',
  'billing.invoiceId': 'Fatura: {id}',
  'billing.refresh': 'Atualizar',
  'billing.upgradePro': 'Fazer upgrade para Pro',
  // Issue #593: o upgrade agora passa pela pagina de planos (Single/Team).
  'billing.viewPlans': 'Ver planos e fazer upgrade',
  'billing.cancel': 'Cancelar assinatura',
  'billing.cancelConfirm': 'Tem certeza que deseja cancelar sua assinatura?',
  'billing.processing': 'Processando...',
  'signup.consentPrefix': 'Li e aceito os',
  'signup.consentAnd': 'e a',
  'signup.consentRequired': 'Você deve aceitar os Termos de Uso e a Política de Privacidade para criar a conta.',

  // ---------------------------------------------------------------------------
  // invite — Invite.tsx (Issue #411 — aceite de convite de equipe)
  // ---------------------------------------------------------------------------
  'invite.title': 'Aceitar Convite',
  'invite.subtitle': 'Você foi convidado para participar de uma organização no Aura Nota. Crie sua senha para continuar.',
  'invite.name': 'Nome (opcional)',
  'invite.namePlaceholder': 'Seu nome',
  'invite.password': 'Senha',
  'invite.passwordHint': 'Mínimo de 8 caracteres.',
  'invite.consent': 'Li e concordo com os Termos de Uso e a Política de Privacidade.',
  'invite.submit': 'Aceitar Convite',
  'invite.successTitle': 'Conta criada!',
  'invite.successMessage': 'Sua conta foi criada e você foi adicionado à organização. Faça login para continuar.',
  'invite.goLogin': 'Ir para login',
  'invite.invalidToken': 'Convite inválido. Solicite um novo convite.',
  'invite.expiredToken': 'Convite expirado. Solicite um novo convite.',
  'invite.error': 'Erro ao aceitar convite. Tente novamente.',
  'invite.errorPassword': 'A senha deve ter no mínimo 8 caracteres.',
  'invite.errorConsent': 'Você deve aceitar os termos para continuar.',

  // ---------------------------------------------------------------------------
  // install — InstallApp.tsx (PWA "Como instalar") — Sprint 7 (#S7-045)
  // ---------------------------------------------------------------------------
  'install.title': 'Instale o Aura Nota',
  'install.subtitle': 'Acesse mais rápido e tenha uma experiência similar a um app nativo',
  'install.button': 'Instalar agora',
  'install.installed': 'App já instalado',
  'install.why_install': 'Por que instalar?',
  'install.benefit_fast': 'Acesso mais rápido com ícone na tela inicial',
  'install.benefit_fullscreen': 'Tela cheia sem barra do navegador',
  'install.benefit_notifications': 'Notificações push',
  'install.benefit_native': 'Experiência similar a app nativo',
  'install.menu_label': 'Como instalar',
  'install.all_browsers_can_install': 'Todos os navegadores podem instalar o Aura Nota. O método de instalação varia por navegador — alguns oferecem instalação com um clique, outros requerem adição manual de atalho.',
  'install.help_button': 'Como instalar o app',
  'install.not_supported': 'Seu navegador não suporta instalação automática. Siga as instruções abaixo para adicionar manualmente.',
  'install.contact_support': 'Se tiver dúvidas, entre em contato com o suporte.',
  'install.instructions_title': 'Instruções por navegador',
  'install.instructions_intro': 'Escolha o navegador que você está usando e siga o passo a passo.',
  'install.compatibility_note': 'A instalação funciona na maioria dos navegadores modernos. A disponibilidade do botão "Instalar agora" depende do suporte do navegador.',
  'install.back_home': 'Voltar ao início',

  'install.chrome_android': 'Chrome (Android)',
  'install.chrome_android.step1': 'Abra o Aura Nota no Chrome do seu celular.',
  'install.chrome_android.step2': 'Toque no menu (três pontinhos ⋮) no canto superior direito.',
  'install.chrome_android.step3': 'Toque em "Instalar app" ou "Adicionar à tela inicial" e confirme.',

  'install.chrome_desktop': 'Chrome (Desktop)',
  'install.chrome_desktop.step1': 'Abra o Aura Nota no Chrome do computador.',
  'install.chrome_desktop.step2': 'Procure o ícone de instalação (⊕) na barra de endereços, ou abra o menu (⋮).',
  'install.chrome_desktop.step3': 'Clique em "Instalar Aura Nota" e confirme.',

  'install.edge_desktop': 'Edge (Desktop)',
  'install.edge_desktop.step1': 'Abra o Aura Nota no Microsoft Edge.',
  'install.edge_desktop.step2': 'Procure o ícone de instalação na barra de endereços, ou abra o menu (⋯).',
  'install.edge_desktop.step3': 'Vá em "Apps" → "Instalar este site como um aplicativo" e confirme.',

  'install.safari_ios': 'Safari (iOS)',
  'install.safari_ios.step1': 'Abra o Aura Nota no Safari do iPhone ou iPad.',
  'install.safari_ios.step2': 'Toque no botão Compartilhar (quadrado com seta para cima □↑).',
  'install.safari_ios.step3': 'Toque em "Adicionar à Tela de Início" e confirme.',

  'install.safari_macos': 'Safari (macOS)',
  'install.safari_macos.step1': 'Abra o Aura Nota no Safari do Mac.',
  'install.safari_macos.step2': 'No menu superior, clique em "Arquivo".',
  'install.safari_macos.step3': 'Selecione "Adicionar ao Dock" e confirme.',

  'install.firefox_android': 'Firefox (Android)',
  'install.firefox_android.step1': 'Abra o Aura Nota no Firefox do celular.',
  'install.firefox_android.step2': 'Toque no menu (três pontinhos ⋮).',
  'install.firefox_android.step3': 'Toque em "Adicionar à tela inicial" e confirme.',

  'install.firefox_desktop': 'Firefox (Desktop)',
  'install.firefox_desktop.step1': 'O Firefox para computador não instala PWAs nativamente.',
  'install.firefox_desktop.step2': 'Arraste o ícone da barra de endereços para a área de trabalho para criar um atalho.',
  'install.firefox_desktop.step3': 'Ou use Marcadores → Mais → "Adicionar à tela inicial" para salvar como atalho.',
  'install.firefox_desktop.note': 'Atalhos abrem o site no navegador, sem experiência de app nativo.',

  // ---------------------------------------------------------------------------
  // team — Team.tsx (Issue #328)
  // ---------------------------------------------------------------------------
  'team.title': 'Equipe & Membros',
  'team.subtitle': 'Gerencie os membros da sua organização.',
  'team.loading': 'Carregando membros...',
  'team.empty': 'Nenhum membro encontrado.',
  'team.error.load': 'Falha ao carregar membros.',
  'team.saving': 'Salvando...',
  'team.col.name': 'Nome',
  'team.col.email': 'E-mail',
  'team.col.role': 'Função',
  'team.col.status': 'Status',
  'team.col.joined': 'Entrou em',
  'team.col.actions': 'Ações',
  'team.role.admin': 'Administrador',
  'team.role.member': 'Membro',
  'team.role.contador': 'Contador',
  'team.role.updated': 'Função atualizada.',
  'team.role.error': 'Falha ao atualizar função.',
  'team.status.active': 'Ativo',
  'team.status.invited': 'Convidado',
  'team.status.disabled': 'Desativado',
  'team.invite.button': 'Convidar membro',
  'team.invite.modalTitle': 'Convidar membro',
  'team.invite.email': 'E-mail',
  'team.invite.role': 'Função',
  'team.invite.cancel': 'Cancelar',
  'team.invite.send': 'Enviar convite',
  'team.invite.success': 'Convite enviado com sucesso.',
  'team.invite.error': 'Falha ao enviar convite.',
  'team.remove.button': 'Remover',
  'team.remove.confirmTitle': 'Remover membro',
  'team.remove.confirmBody': 'Tem certeza que deseja remover {email} da organização?',
  'team.remove.cancel': 'Cancelar',
  'team.remove.confirm': 'Remover',
  'team.remove.success': 'Membro removido.',
  'team.remove.error': 'Falha ao remover membro.',
  'team.invites.title': 'Convites Pendentes',
  'team.invites.empty': 'Nenhum convite pendente.',
  'team.invites.col.sentAt': 'Enviado em',
  'team.invites.col.expiresAt': 'Expira em',
  'team.invite.cancel.button': 'Remover',
  'team.invite.cancel.confirmTitle': 'Remover Convite',
  'team.invite.cancel.confirmBody': 'Tem certeza que deseja remover este convite? O convidado nao podera aceita-lo.',
  'team.invite.cancel.success': 'Convite removido.',
  'team.invite.cancel.error': 'Falha ao remover convite.',
  'team.invite.resend.button': 'Reenviar',
  'team.invite.resend.success': 'Convite reenviado com sucesso!',
  'team.invite.resend.error': 'Erro ao reenviar convite.',

  // ---------------------------------------------------------------------------
  // admin — AdminPanel.tsx (Issue #332)
  // ---------------------------------------------------------------------------
  'admin.title': 'Painel Administrativo',
  'admin.subtitle': 'Visão global de organizações, usuários e métricas.',
  // Issue #550 (feat/audit-gestao): chaves admin.tab.* removidas — a tab de
  // auditoria saiu do AdminPanel (virou pagina propria no grupo "Gestao").
  'admin.loading': 'Carregando dados...',
  'admin.error.load': 'Falha ao carregar dados administrativos.',
  'admin.role.super_user': 'Super Usuário',
  'admin.role.admin': 'Administrador',
  'admin.role.member': 'Membro',
  'admin.role.contador': 'Contador',
  'admin.metric.totalDocs': 'Documentos',
  'admin.metric.totalUsers': 'Usuários',
  'admin.metric.totalOrgs': 'Organizações',
  'admin.metric.totalOrgsHint': 'total',
  'admin.metric.activeOrgs': 'Orgs ativas',
  'admin.metric.errorRate': 'Taxa de erro',
  'admin.metric.errors': 'erros',
  'admin.orgs.title': 'Organizações',
  'admin.orgs.empty': 'Nenhuma organização encontrada.',
  'admin.orgs.col.name': 'Organização',
  'admin.orgs.col.docs': 'Docs',
  'admin.orgs.col.users': 'Usuários',
  'admin.orgs.col.status': 'Status',
  'admin.orgs.col.created': 'Criada em',
  'admin.users.title': 'Usuários',
  'admin.users.empty': 'Nenhum usuário encontrado.',
  'admin.users.col.email': 'E-mail',
  'admin.users.col.org': 'Organização',
  'admin.users.col.role': 'Função',
  'admin.users.col.status': 'Status',
  'admin.users.col.created': 'Criado em',
  'admin.users.active': 'Ativo',
  'admin.users.disabled': 'Desativado',
  'admin.showTest': 'Mostrar dados de teste',
  'admin.testBadge': 'Teste',

  'admin.orgs.col.actions': 'Ações',
  'admin.impersonate': 'Acessar como',
  // Issue #544: gestao de cupons de desconto (super_user).
  'admin.coupons.title': 'Cupons de desconto',
  'admin.coupons.subtitle': 'Crie e gerencie cupons aplicáveis na assinatura de planos pagos.',
  'admin.coupons.empty': 'Nenhum cupom criado.',
  'admin.coupons.error.load': 'Falha ao carregar cupons.',
  'admin.coupons.error.create': 'Falha ao salvar cupom.',
  'admin.coupons.typePercent': 'Percentual (%)',
  'admin.coupons.typeFixed': 'Valor fixo (R$)',
  'admin.coupons.unlimited': 'Ilimitado',
  'admin.coupons.allPlans': 'Todos os pagos',
  'admin.coupons.active': 'Ativo',
  'admin.coupons.inactive': 'Inativo',
  'admin.coupons.deactivate': 'Desativar',
  'admin.coupons.col.code': 'Código',
  'admin.coupons.col.type': 'Tipo',
  'admin.coupons.col.value': 'Valor',
  'admin.coupons.col.uses': 'Usos',
  'admin.coupons.col.expires': 'Validade',
  'admin.coupons.col.plans': 'Planos',
  'admin.coupons.col.status': 'Status',
  'admin.coupons.col.actions': 'Ações',
  'admin.coupons.form.code': 'Código',
  // Security review #544: minimo 8 chars — orientar codigo nao-trivial.
  'admin.coupons.form.codeHint': 'Mín. 8 caracteres — use código não-trivial (ex.: CAMPANHA-2026-X4K9).',
  'admin.coupons.form.discountType': 'Tipo',
  'admin.coupons.form.value': 'Valor',
  'admin.coupons.form.maxUses': 'Máx. usos global',
  'admin.coupons.form.maxUsesPerOrg': 'Máx. usos por org',
  'admin.coupons.form.expiresAt': 'Expira em',
  'admin.coupons.form.eligiblePlans': 'Planos elegíveis (vazio = todos)',
  'admin.coupons.form.submit': 'Criar cupom',
  'admin.coupons.form.saving': 'Salvando...',
  'impersonation.banner': 'Você está acessando como {name}',
  'impersonation.exit': 'Sair',
  'impersonation.exiting': 'Saindo...',
  'impersonation.confirmTitle': 'Acessar como cliente',
  'impersonation.confirmBody': 'Você vai acessar o sistema como se fosse o cliente "{name}". Todas as ações serão auditadas.',
  'impersonation.cancel': 'Cancelar',
  'impersonation.confirm': 'Acessar',
  'impersonation.starting': 'Iniciando...',
  'layout.nav.sefaz': 'Buscar por Chave',
  'sefaz.title': 'Buscar NF-e por Chave de Acesso',
  'sefaz.tab.individual': 'Individual',
  'sefaz.tab.batch': 'Lote (Excel)',
  'sefaz.individual.label': 'Chave de Acesso (44 dígitos)',
  'sefaz.individual.invalid': 'Chave inválida: deve ter 44 dígitos com dígito verificador válido',
  'sefaz.individual.valid': 'Chave válida',
  'sefaz.individual.search': 'Buscar',
  'sefaz.individual.result': 'Resultado da busca',
  'sefaz.individual.goToDocs': 'Ver documento em Documentos',
  'sefaz.status': 'Status',
  'sefaz.batch.downloadTemplate': 'Baixar Template Excel',
  'sefaz.batch.dropHere': 'Arraste um arquivo .xlsx aqui ou clique para selecionar',
  'sefaz.batch.errorFormat': 'Arquivo deve ser .xlsx',
  'sefaz.batch.progress': 'Progresso do lote',
  'sefaz.batch.total': 'Total',
  'sefaz.batch.processed': 'Processadas',
  'sefaz.batch.success': 'Sucesso',
  'sefaz.batch.error': 'Erros',
  'sefaz.batch.status': 'Status',
  'sefaz.batch.goToDocs': 'Ver documentos criados',
  'sefaz.batch.history': 'Lotes anteriores',
  'sefaz.batch.export': 'Exportar resultado',
  'layout.nav.sefazGroup': 'Fiscal / SEFAZ',
  'sefaz.nav.status': 'Status de serviço',
  'sefaz.nav.consulta': 'Consulta por chave',
  'sefaz.nav.dfe': 'Distribuição DF-e por NSU',
  'sefaz.nav.certs': 'Certificados',
  'sefaz.statusPage.title': 'Status de serviço SEFAZ',
  'sefaz.statusPage.ufLabel': 'UF',
  'sefaz.statusPage.tab.nfe': 'NF-e',
  'sefaz.statusPage.tab.cte': 'CT-e',
  'sefaz.statusPage.tab.mdfe': 'MDF-e',
  'sefaz.statusPage.consult': 'Consultar',
  'sefaz.statusPage.cstat': 'cStat',
  'sefaz.statusPage.xmotivo': 'Motivo',
  'sefaz.statusPage.uf': 'UF',
  'sefaz.statusPage.timestamp': 'Data/hora',
  'sefaz.statusPage.rateLimited': 'Limite de requisições excedido. Tente novamente em {s}s.',
  'sefaz.statusPage.unavailable': 'Serviço SEFAZ indisponível no momento. Tente novamente em instantes.',
  'sefaz.gated.title': 'Requer certificado A1 configurado',
  'sefaz.gated.body': 'Esta consulta exige um certificado digital A1 vinculado à organização. Cadastre-o em Fiscal/SEFAZ > Certificados.',
  'sefaz.gated.cta': 'Ir para Certificados',
  'sefaz.dfe.title': 'Distribuição DF-e por NSU',
  'sefaz.dfe.nsuLabel': 'Último NSU (15 dígitos)',
  'sefaz.certs.title': 'Gestão de certificados A1',
  'sefaz.certs.badge': 'Em breve',
  'sefaz.certs.body': 'Aqui você poderá cadastrar e gerenciar o certificado digital A1 da organização, necessário para consultas autenticadas à SEFAZ (consulta por chave e distribuição DF-e).',
  // Sprint 14 (issue #482): página real de custódia de certificados A1.
  'sefaz.certs.subtitle': 'Certificado digital A1 (e-CNPJ) usado nas consultas autenticadas à SEFAZ.',
  'sefaz.certs.retry': 'Tentar novamente',
  'sefaz.certs.tab.detail': 'Certificado',
  'sefaz.certs.tab.history': 'Histórico',
  'sefaz.certs.empty.title': 'Nenhum certificado cadastrado',
  'sefaz.certs.empty.body': 'Envie o certificado digital A1 (.pfx/.p12) da organização para habilitar consultas autenticadas à SEFAZ.',
  'sefaz.certs.empty.memberHint': 'A organização ainda não possui certificado digital cadastrado. Peça a um administrador para enviá-lo.',
  'sefaz.certs.empty.cta': 'Enviar certificado',
  'sefaz.certs.member.title': 'Certificado digital da organização',
  'sefaz.certs.member.absent': 'Nenhum certificado digital cadastrado.',
  'sefaz.certs.member.configured': 'Certificado digital configurado e ativo.',
  'sefaz.certs.member.expiring': 'O certificado digital vence em {n} dia(s).',
  'sefaz.certs.member.expired': 'O certificado digital está vencido.',
  'sefaz.certs.member.hint': 'A gestão do certificado é restrita a administradores da organização.',
  'sefaz.certs.expiredBanner': 'O certificado digital está vencido — as consultas à SEFAZ estão indisponíveis até a rotação.',
  'sefaz.certs.expiredCta': 'Rotacionar agora',
  'sefaz.certs.meta.title': 'Certificado custodiado',
  'sefaz.certs.meta.cn': 'Nome (CN)',
  'sefaz.certs.meta.issuer': 'Emissor',
  'sefaz.certs.meta.serial': 'Número de série',
  'sefaz.certs.meta.cnpj': 'CNPJ',
  'sefaz.certs.meta.validFrom': 'Válido desde',
  'sefaz.certs.meta.validTo': 'Válido até',
  'sefaz.certs.meta.fingerprint': 'Fingerprint SHA-256',
  'sefaz.certs.meta.uploadedAt': 'Enviado em',
  'sefaz.certs.meta.uploadedBy': 'Enviado por',
  'sefaz.certs.meta.lastSession': 'Última sessão MCP',
  'sefaz.certs.status.ativo': 'Ativo',
  'sefaz.certs.status.ausente': 'Sem certificado',
  'sefaz.certs.status.vencendo': 'Vence em {n} dias',
  'sefaz.certs.status.expirado': 'Expirado',
  'sefaz.certs.status.pendente': 'Pendente de consentimento',
  'sefaz.certs.status.removido': 'Removido',
  'sefaz.certs.actions.rotate': 'Rotacionar certificado',
  'sefaz.certs.actions.remove': 'Remover certificado',
  'sefaz.certs.upload.titleCreate': 'Enviar certificado A1',
  'sefaz.certs.upload.titleRotate': 'Rotacionar certificado A1',
  'sefaz.certs.upload.dropzone': 'Arraste o arquivo do certificado aqui ou clique para selecionar',
  'sefaz.certs.upload.formats': 'Formatos aceitos: .pfx ou .p12 — máximo 64 KB',
  'sefaz.certs.upload.changeFile': 'clique para trocar o arquivo',
  'sefaz.certs.upload.fileErrorExt': 'Arquivo inválido: envie um certificado .pfx ou .p12 (A1).',
  'sefaz.certs.upload.fileErrorSize': 'Arquivo excede o limite de 64 KB.',
  'sefaz.certs.upload.passwordLabel': 'Senha do certificado',
  'sefaz.certs.upload.passwordHint': 'A senha é usada apenas para validar o certificado e é armazenada cifrada — nunca é exibida nem salva no navegador.',
  'sefaz.certs.upload.submitCreate': 'Validar e custodiar',
  'sefaz.certs.upload.submitRotate': 'Validar e rotacionar',
  'sefaz.certs.upload.successCreate': 'Certificado enviado e custodiado com sucesso.',
  'sefaz.certs.upload.successRotate': 'Certificado rotacionado com sucesso.',
  'sefaz.certs.consent.text': 'Autorizo o Aura Nota a custodiar o certificado digital A1 da organização (CNPJ {cnpj}) de forma cifrada, usá-lo exclusivamente para consultas fiscais em meu nome por meio de sessões transitórias, e reconheço que posso revogar esta autorização e remover o certificado a qualquer momento.',
  'sefaz.certs.consent.textNoCnpj': 'Autorizo o Aura Nota a custodiar o certificado digital A1 da organização de forma cifrada, usá-lo exclusivamente para consultas fiscais em meu nome por meio de sessões transitórias, e reconheço que posso revogar esta autorização e remover o certificado a qualquer momento.',
  'sefaz.certs.consent.linkLabel': 'Ler o termo de custódia',
  'sefaz.certs.mismatch.title': 'CNPJ divergente',
  'sefaz.certs.mismatch.body': 'O CNPJ do novo certificado não confere com o CNPJ da organização. Só confirme se a organização realmente mudou de CNPJ ou se este certificado pertence ao titular correto.',
  'sefaz.certs.mismatch.confirm': 'Confirmar divergência e rotacionar',
  'sefaz.certs.remove.title': 'Remover certificado',
  'sefaz.certs.remove.impact': 'Impacto: as consultas fiscais (SEFAZ/RFB) desta organização ficam indisponíveis até o envio de um novo certificado. O material cifrado é apagado imediatamente e a sessão MCP é encerrada.',
  'sefaz.certs.remove.confirmLabel': 'Entendo o impacto e confirmo a remoção do certificado custodiado.',
  'sefaz.certs.remove.confirm': 'Remover definitivamente',
  'sefaz.certs.remove.success': 'Certificado removido da custódia.',
  'sefaz.certs.history.col.action': 'Ação',
  'sefaz.certs.history.col.user': 'Usuário',
  'sefaz.certs.history.col.timestamp': 'Data/hora',
  'sefaz.certs.history.col.ip': 'IP',
  'sefaz.certs.history.empty': 'Nenhum evento registrado para este certificado.',
  'sefaz.certs.history.prev': 'Anterior',
  'sefaz.certs.history.next': 'Próxima',
  'sefaz.certs.history.page': 'Página {page} de {pages}',
  'sefaz.certs.history.action.cert_upload': 'Upload de certificado',
  'sefaz.certs.history.action.cert_view': 'Visualização de metadados',
  'sefaz.certs.history.action.cert_rotate': 'Rotação de certificado',
  'sefaz.certs.history.action.cert_delete': 'Remoção de certificado',
  'sefaz.certs.history.action.cert_use': 'Uso em consulta SEFAZ',
  'sefaz.certs.history.action.cert_consent_grant': 'Consentimento registrado',
  'sefaz.certs.history.action.cert_consent_revoke': 'Consentimento revogado',
  'sefaz.certs.history.action.cert_session_open': 'Sessão MCP aberta',
  'sefaz.certs.error.invalidPfx': 'Senha do certificado incorreta ou arquivo inválido.',
  'sefaz.certs.error.invalidChain': 'Certificado não é A1 ICP-Brasil (e-CPF, A3 ou autoassinados não são aceitos).',
  'sefaz.certs.error.expired': 'Certificado vencido — envie um certificado válido.',
  'sefaz.certs.error.cnpjMismatch': 'O CNPJ do certificado não confere com o CNPJ da organização.',
  'sefaz.certs.error.rateLimited': 'Limite de tentativas excedido. Tente novamente em {min} min.',
  'sefaz.certs.error.uploadDisabled': 'O upload de certificados está desabilitado neste ambiente.',
  'sefaz.certs.error.noOrgCnpj': 'Cadastre o CNPJ da organização antes de enviar o certificado.',
  'sefaz.certs.error.pfxTooLarge': 'Arquivo de certificado excede o limite aceito.',
  'sefaz.certs.error.alreadyExists': 'Já existe um certificado custodiado — use a rotação para substituí-lo.',
  'sefaz.certs.error.consentRequired': 'É necessário aceitar o termo de custódia para continuar.',
  'sefaz.certs.error.confirmRequired': 'Confirme a operação para continuar.',
  'sefaz.certs.error.unavailable': 'Serviço de consulta fiscal indisponível. Tente novamente em instantes.',
  'sefaz.certs.error.forbidden': 'Você não tem permissão para esta ação.',
  'sefaz.certs.error.validation': 'Dados do certificado inválidos.',
  'sefaz.certs.error.generic': 'Não foi possível concluir a operação.',

  // ---------------------------------------------------------------------------
  // catalogo — catálogo colaborativo de municípios/provedores (S10-T06)
  // ---------------------------------------------------------------------------
  'layout.nav.catalogo': 'Municípios',
  'catalogo.title': 'Catálogo de Municípios',
  'catalogo.subtitle': 'Mapeamento colaborativo município → provedor NFS-e.',
  'catalogo.stats.municipios': 'Municípios cobertos',
  'catalogo.stats.provedores': 'Provedores suportados',
  'catalogo.stats.ufs': 'UFs cobertas',
  'catalogo.stats.pendentes': 'Sugestões pendentes',
  'catalogo.table.title': 'Municípios',
  'catalogo.table.ibge': 'IBGE',
  'catalogo.table.nome': 'Município',
  'catalogo.table.uf': 'UF',
  'catalogo.table.provedor': 'Provedor',
  'catalogo.table.agregador': 'Agregador',
  'catalogo.table.empty': 'Nenhum município encontrado.',
  'catalogo.filter.uf': 'UF',
  'catalogo.filter.provedor': 'Provedor',
  'catalogo.filter.busca': 'Buscar município',
  'catalogo.export': 'Exportar JSON',
  'catalogo.import': 'Importar JSON',
  'catalogo.import.result': 'Importação: {created} criados, {updated} atualizados ({total} itens).',
  'catalogo.suggest.title': 'Sugerir mapeamento',
  'catalogo.suggest.ibge': 'Código IBGE',
  'catalogo.suggest.nome': 'Município',
  'catalogo.suggest.uf': 'UF',
  'catalogo.suggest.provedor': 'Provedor',
  'catalogo.suggest.agregador': 'Agregador (opcional)',
  'catalogo.suggest.justificativa': 'Justificativa (opcional)',
  'catalogo.suggest.submit': 'Enviar sugestão',
  'catalogo.suggest.success': 'Sugestão enviada para moderação.',
  // Issue #559 → decisão de produto: página "Solicitar provedor" para
  // roles de org (catálogo completo só super_user; parceiro modera a fila
  // de sugestões na nova página).
  'layout.nav.requestProvider': 'Solicitar provedor',
  'catalogo.request.subtitle': 'Veja os provedores NFS-e suportados hoje e solicite cobertura para o município da sua organização.',
  'catalogo.supported.notice': 'Estes são os provedores NFS-e homologados hoje e os municípios cobertos por cada um. Se o provedor do seu município não está na lista, envie uma solicitação abaixo.',
  'catalogo.table.justificativa': 'Justificativa',
  'catalogo.moderation.queue': 'Fila de moderação',
  'catalogo.moderation.queueEmpty': 'Nenhuma solicitação pendente.',
  'catalogo.supported.line': 'Provedores suportados atualmente: {list}',
  'catalogo.supported.title': 'Municípios e provedores suportados',
  'catalogo.status.supported': 'Suportado',
  'catalogo.request.title': 'Solicitar provedor',
  'catalogo.request.submit': 'Enviar solicitação',
  'catalogo.sugestoes.mine': 'Minhas solicitações',
  'catalogo.sugestoes.mineEmpty': 'Nenhuma solicitação enviada.',
  'catalogo.sugestoes.title': 'Sugestões',
  'catalogo.sugestoes.empty': 'Nenhuma sugestão.',
  'catalogo.sugestoes.status.pendente': 'Pendente',
  'catalogo.sugestoes.status.aprovada': 'Aprovada',
  'catalogo.sugestoes.status.rejeitada': 'Rejeitada',
  'catalogo.moderation.actions': 'Ações',
  'catalogo.moderation.approve': 'Aprovar',
  'catalogo.moderation.reject': 'Rejeitar',
  'catalogo.moderation.rejectPrompt': 'Motivo da rejeição (opcional):',
  'catalogo.history.title': 'Histórico do catálogo',
  'catalogo.history.action': 'Ação',
  'catalogo.history.action.create': 'Criação',
  'catalogo.history.action.update': 'Atualização',
  'catalogo.history.action.delete': 'Remoção',
  'catalogo.history.origem.admin': 'Edição direta',
  'catalogo.history.origem.sugestao': 'Sugestão aprovada',
  'catalogo.history.origem.import': 'Importação',
  'catalogo.history.empty': 'Nenhuma alteração registrada.',
  'catalogo.error.generic': 'Não foi possível concluir a operação.',

  // ---------------------------------------------------------------------------
  // settings — TenantSettings.tsx (S10-T01, painel administrativo do tenant)
  // ---------------------------------------------------------------------------
  'layout.nav.settings': 'Configurações',
  'settings.title': 'Configurações do Tenant',
  'settings.subtitle': 'Painel administrativo da organização: usuários, provedores, e-mail, retenção e thresholds.',
  'settings.loading': 'Carregando...',
  'settings.saving': 'Salvando...',
  'settings.save': 'Salvar',
  'settings.cancel': 'Cancelar',
  'settings.close': 'Fechar',
  'settings.edit': 'Editar',
  'settings.delete': 'Excluir',
  'settings.error.load': 'Erro ao carregar configurações.',
  'settings.error.action': 'Erro ao executar a ação.',
  'settings.tab.users': 'Usuários',
  'settings.tab.providers': 'Provedores',
  'settings.tab.email': 'E-mail',
  'settings.tab.retention': 'Retenção',
  'settings.tab.thresholds': 'Thresholds',

  // Roles (perfis S10-T02)
  'settings.role.admin': 'Administrador',
  'settings.role.owner': 'Administrador',
  'settings.role.member': 'Membro',
  'settings.role.contador': 'Contador',
  'settings.role.parceiro': 'Parceiro',
  'settings.role.revisor': 'Revisor',
  'settings.role.financeiro': 'Financeiro',
  'settings.role.operador': 'Operador',
  'settings.role.auditor': 'Auditor',
  'settings.role.super_user': 'Super Usuário',

  // Tab: usuarios
  'settings.users.subtitle': 'Gerencie os usuários da organização: convide, altere perfis, desative ou resete senhas.',
  'settings.users.inviteButton': 'Convidar usuário',
  'settings.users.inviteTitle': 'Convidar usuário',
  'settings.users.sendInvite': 'Enviar convite',
  'settings.users.inviteSuccess': 'Convite enviado com sucesso.',
  'settings.users.inviteError': 'Erro ao enviar convite.',
  'settings.users.pendingInvites': 'Convites pendentes',
  'settings.users.resend': 'Reenviar',
  'settings.users.cancelInvite': 'Cancelar',
  'settings.users.col.email': 'E-mail',
  'settings.users.col.role': 'Perfil',
  'settings.users.col.status': 'Status',
  'settings.users.col.joined': 'Desde',
  'settings.users.col.actions': 'Ações',
  'settings.users.active': 'Ativo',
  'settings.users.disabled': 'Desativado',
  'settings.users.activate': 'Reativar',
  'settings.users.deactivate': 'Desativar',
  'settings.users.resetPassword': 'Resetar senha',
  'settings.users.remove': 'Remover',
  'settings.users.removeConfirm': 'Remover {email} da organização?',
  'settings.users.resetConfirm': 'Resetar a senha de {email}? Uma senha temporária será gerada.',
  'settings.users.resetTitle': 'Senha temporária gerada',
  'settings.users.resetBody': 'Nova senha temporária de {email}. Repasse por canal seguro — ela não será exibida novamente:',

  // Tab: provedores
  'settings.providers.subtitle': 'Catálogo de municípios e provedores de NFS-e (adicionar/editar mapeamentos).',
  'settings.providers.searchPlaceholder': 'Buscar município...',
  'settings.providers.addButton': 'Adicionar provedor',
  'settings.providers.addTitle': 'Adicionar município/provedor',
  'settings.providers.editTitle': 'Editar município/provedor',
  'settings.providers.empty': 'Nenhum município encontrado.',
  'settings.providers.saved': 'Provedor salvo com sucesso.',
  'settings.providers.deleted': 'Provedor removido.',
  'settings.providers.deleteConfirm': 'Remover o mapeamento de {name}?',
  'settings.providers.col.ibge': 'Cód. IBGE',
  'settings.providers.col.name': 'Município',
  'settings.providers.col.uf': 'UF',
  'settings.providers.col.provider': 'Provedor',
  'settings.providers.col.aggregator': 'Agregador',
  // Issue #547: catalogo global — org admins so sugerem (nao editam).
  'settings.providers.globalNotice': 'O catálogo de provedores é global e gerenciado pela plataforma — solicite novos mapeamentos aqui.',
  'settings.providers.suggestTitle': 'Solicitar provedor/município',
  'settings.providers.mySuggestions': 'Sugestões da sua organização',

  // Tab: e-mail
  'settings.email.imapTitle': 'IMAP — captura de e-mails',
  'settings.email.imapSubtitle': 'Caixas de e-mail monitoradas para captura automática de notas fiscais.',
  'settings.email.addImap': 'Adicionar IMAP',
  'settings.email.editImap': 'Editar IMAP',
  'settings.email.empty': 'Nenhuma configuração IMAP cadastrada.',
  'settings.email.saved': 'Configuração IMAP salva.',
  'settings.email.deleted': 'Configuração IMAP removida.',
  'settings.email.deleteConfirm': 'Remover a configuração IMAP de {host}?',
  'settings.email.test': 'Testar',
  'settings.email.testing': 'Testando...',
  'settings.email.smtpTitle': 'SMTP — envio de e-mails',
  'settings.email.smtpSubtitle': 'Servidor SMTP da organização para envio de e-mails (convites, notificações).',
  'settings.email.saveSmtp': 'Salvar SMTP',
  'settings.email.smtpSaved': 'Configuração SMTP salva.',
  'settings.email.col.host': 'Servidor',
  'settings.email.col.port': 'Porta',
  'settings.email.col.user': 'Usuário',
  'settings.email.col.password': 'Senha',
  'settings.email.col.folder': 'Pasta',
  'settings.email.col.from': 'Remetente (From)',
  'settings.email.useTls': 'Usar TLS',
  'settings.email.enabled': 'Habilitado',
  'settings.email.passwordSet': 'senha salva',
  'settings.email.keepPassword': 'deixe vazio para manter',
  // Issue #542: whitelist de remetentes + opt-out explicito no modal IMAP.
  'settings.email.allowedSenders': 'Remetentes autorizados',
  'settings.email.allowedSendersHint':
    'Um e-mail por linha. Use *@dominio.com.br para autorizar um domínio inteiro.',
  'settings.email.allowedSendersAuthHint':
    'A whitelist filtra pelo remetente declarado; a verificação de autenticidade (SPF/DKIM via Authentication-Results) depende do provedor da caixa.',
  'settings.email.acceptAnySender':
    'Aceitar e-mails de qualquer remetente (não recomendado)',
  'settings.email.acceptAnyWarning':
    'A caixa aceita anexos de qualquer remetente — recomendado configurar a lista de remetentes autorizados.',

  // Issue #555 — captura dedicada por tenant (endereco captura-<slug>-<token>).
  'settings.email.captureTitle': 'Captura por e-mail',
  'settings.email.captureSubtitle':
    'Endereço dedicado da sua organização. Encaminhe e-mails com NFS-e/PDF como anexo para este endereço — os documentos entram automaticamente na sua conta.',
  'settings.email.captureCopy': 'Copiar',
  'settings.email.captureCopied': 'Copiado!',
  'settings.email.captureCopyError': 'Não foi possível copiar — selecione o endereço manualmente.',
  'settings.email.captureRegenerate': 'Regenerar endereço',
  'settings.email.captureRegenerateHint':
    'Ao regenerar, o endereço atual deixa de funcionar imediatamente — e-mails enviados a ele não serão mais capturados.',
  'settings.email.captureRegenerateConfirm':
    'Regenerar o endereço de captura?\n\nO endereço atual ({address}) deixará de funcionar — e-mails enviados a ele não serão mais capturados. Esta ação não pode ser desfeita.',
  'settings.email.captureRegenerated': 'Endereço de captura regenerado.',
  // Issue #570 — allowlist de remetentes da captura dedicada.
  'settings.email.captureSendersTitle': 'Remetentes permitidos',
  'settings.email.captureSendersHint':
    'Membros da equipe são sempre permitidos. Adicione abaixo outros e-mails autorizados a enviar para este endereço (somente endereços individuais — domínios não são aceitos).',
  'settings.email.captureSenderPlaceholder': 'email@empresa.com.br',
  'settings.email.captureSenderAdd': 'Adicionar',
  'settings.email.captureSenderRemove': 'Remover',
  'settings.email.captureSenderAdded': 'Remetente adicionado à lista de permitidos.',
  'settings.email.captureSenderRemoved': 'Remetente removido da lista de permitidos.',
  'settings.email.captureSendersRejectNote':
    'E-mails de remetentes fora desta lista são recusados automaticamente, sem nenhum processamento.',

  // Tab: retencao
  'settings.retention.subtitle': 'Período de retenção de dados da organização (conformidade LGPD e guarda fiscal).',
  'settings.retention.daysLabel': 'Retenção de dados (dias)',
  'settings.retention.hint': 'Entre 30 e 3650 dias. Padrão: 1825 dias (5 anos — guarda fiscal).',
  // Issue #560 — aviso: retenção não apaga documentos automaticamente
  'settings.retention.notice': 'Quando um documento ultrapassar o período de retenção, os administradores da organização receberão um alerta para revisão. Nenhum documento é excluído automaticamente.',
  'settings.retention.saved': 'Retenção atualizada.',

  // Tab: thresholds
  'settings.thresholds.subtitle': 'Thresholds de validação da extração: confiança do VLM, aprovação automática e revisão.',
  'settings.thresholds.vlm': 'Confiança VLM (0–1)',
  'settings.thresholds.vlmHint': 'Confiança mínima do modelo VLM; abaixo disso usa o fallback.',
  'settings.thresholds.autoApprove': 'Auto-aprovação (0–1)',
  'settings.thresholds.autoApproveHint': 'Confiança mínima para aprovar automaticamente sem revisão.',
  'settings.thresholds.needsReview': 'Revisão necessária (0–1)',
  'settings.thresholds.needsReviewHint': 'Abaixo desta confiança o documento vai para a fila de revisão.',
  'settings.thresholds.saved': 'Thresholds atualizados.',

  // ---------------------------------------------------------------------------
  // onboarding — wizard assistido do tenant (S10-T07, US-S10-007)
  // ---------------------------------------------------------------------------
  'layout.nav.onboarding': 'Onboarding',
  'onboarding.title': 'Onboarding assistido',
  'onboarding.subtitle': 'Configure a organização passo a passo: e-mail, municípios, thresholds e um tour pela interface.',
  'onboarding.progress': '{done} de {total} etapas',
  'onboarding.error.load': 'Erro ao carregar o checklist de onboarding.',
  'onboarding.error.action': 'Erro ao executar a ação.',
  'onboarding.step.email': 'E-mail',
  'onboarding.step.municipios': 'Municípios',
  'onboarding.step.thresholds': 'Thresholds',
  'onboarding.step.tour': 'Tour guiado',
  'onboarding.step.auto': 'detectado',
  'onboarding.step.autoHint': 'Etapa já satisfeita pela configuração atual da organização.',
  'onboarding.step.complete': 'Concluir etapa',
  'onboarding.step.completeHint': 'A etapa só pode ser concluída quando a configuração correspondente já estiver salva.',
  'onboarding.step.done': 'Etapa concluída',
  'onboarding.nav.prev': 'Voltar',
  'onboarding.nav.next': 'Avançar',
  'onboarding.finish': 'Concluir onboarding',
  'onboarding.help.title': 'Ajuda',
  'onboarding.help.email': 'Configure uma caixa IMAP para captura automática de notas e/ou o SMTP de envio. Depois do onboarding, gerencie tudo em Configurações → E-mail.',
  'onboarding.help.municipios': 'Selecione os municípios cuja NFS-e sua organização recebe. A seleção vem do catálogo colaborativo município → provedor.',
  'onboarding.help.thresholds': 'Defina os thresholds de validação da extração. Você pode ajustá-los depois em Configurações → Thresholds.',
  'onboarding.help.tour': 'O tour mostra as principais áreas da interface. Você pode pulá-lo e concluir a etapa manualmente.',
  'onboarding.help.link.settingsEmail': 'Abrir Configurações',
  'onboarding.help.link.settingsThresholds': 'Abrir Configurações',
  'onboarding.help.link.catalogo': 'Abrir catálogo de municípios',
  'onboarding.email.title': 'E-mail (captura e envio)',
  'onboarding.email.subtitle': 'Configure a caixa IMAP monitorada e/ou o servidor SMTP da organização, com teste de conexão.',
  'onboarding.email.imapDetected': 'IMAP configurado',
  'onboarding.email.smtpDetected': 'SMTP configurado',
  'onboarding.email.imapLegend': 'IMAP — captura de notas',
  'onboarding.email.imapHint': 'Caixa de e-mail monitorada para captura automática de NFS-e/faturas.',
  'onboarding.email.smtpLegend': 'SMTP — envio de e-mails',
  'onboarding.email.smtpHint': 'Servidor SMTP para envio de convites e notificações.',
  'onboarding.email.saveImap': 'Salvar e testar IMAP',
  'onboarding.email.imapSaved': 'IMAP salvo.',
  'onboarding.email.saveSmtp': 'Salvar SMTP',
  'onboarding.email.smtpSaved': 'SMTP salvo.',
  'onboarding.email.testSmtp': 'Testar conexão SMTP',
  'onboarding.email.testOk': 'Teste de conexão: {message}',
  'onboarding.email.testFail': 'Falha no teste: {error}',
  'onboarding.email.tip.host': 'Endereço do servidor de e-mail (ex.: imap.exemplo.com ou smtp.exemplo.com).',
  'onboarding.email.tip.password': 'Senha ou senha de app da caixa de e-mail. É armazenada criptografada.',
  'onboarding.email.tip.testSmtp': 'Salve o SMTP antes de testar — o teste usa a configuração já persistida.',
  'onboarding.municipios.title': 'Municípios monitorados',
  'onboarding.municipios.subtitle': 'Selecione no catálogo os municípios dos quais sua organização recebe NFS-e.',
  'onboarding.municipios.searchPlaceholder': 'Buscar município por nome...',
  'onboarding.municipios.search': 'Buscar',
  'onboarding.municipios.searching': 'Buscando...',
  'onboarding.municipios.empty': 'Nenhum município encontrado no catálogo.',
  'onboarding.municipios.selected': 'Selecionado',
  'onboarding.municipios.add': 'Adicionar',
  'onboarding.municipios.remove': 'Remover',
  'onboarding.municipios.count': '{count} município(s) selecionado(s).',
  'onboarding.municipios.save': 'Salvar seleção',
  'onboarding.municipios.update': 'Atualizar seleção',
  'onboarding.municipios.saved': 'Seleção salva ({count} municípios).',
  'onboarding.thresholds.title': 'Thresholds de validação',
  'onboarding.thresholds.subtitle': 'Confiança mínima do VLM, auto-aprovação e fila de revisão — valores padrão já preenchidos.',
  'onboarding.thresholds.save': 'Salvar thresholds',
  'onboarding.thresholds.saved': 'Thresholds salvos.',
  'onboarding.tour.title': 'Tour guiado pela interface',
  'onboarding.tour.subtitle': 'Um passo a passo interativo pelas principais áreas do sistema.',
  'onboarding.tour.start': 'Iniciar tour',
  'onboarding.tour.next': 'Próximo',
  'onboarding.tour.prev': 'Anterior',
  'onboarding.tour.skip': 'Pular tour',
  'onboarding.tour.finish': 'Concluir',
  'onboarding.tour.counter': '{current}/{total}',
  'onboarding.tour.step.intro.title': 'Bem-vindo ao Aura Nota',
  'onboarding.tour.step.intro.body': 'Este tour rápido mostra onde ficam as principais áreas: upload, documentos, catálogo e configurações.',
  'onboarding.tour.step.upload.title': 'Upload de documentos',
  'onboarding.tour.step.upload.body': 'Envie PDFs, XMLs e imagens de NFS-e e faturas aqui — a extração é automática.',
  'onboarding.tour.step.documents.title': 'Documentos',
  'onboarding.tour.step.documents.body': 'Todos os documentos capturados ficam aqui, com status de extração e revisão.',
  'onboarding.tour.step.catalogo.title': 'Catálogo de municípios',
  'onboarding.tour.step.catalogo.body': 'Consulte a cobertura município → provedor NFS-e e sugira novos mapeamentos.',
  'onboarding.tour.step.settings.title': 'Configurações do tenant',
  'onboarding.tour.step.settings.body': 'Gerencie usuários, provedores, e-mail, retenção e thresholds da organização.',
  'onboarding.tour.step.done.title': 'Tour concluído',
  'onboarding.tour.step.done.body': 'Pronto! Conclua a etapa para finalizar o checklist de onboarding.',
  'onboarding.done.title': 'Onboarding concluído!',
  'onboarding.done.body': 'A organização está configurada e pronta para capturar documentos.',
  'onboarding.done.notified': '{count} parceiro(s) notificado(s) da conclusão.',
  'onboarding.done.goUpload': 'Enviar primeiro documento',
  'onboarding.done.goSettings': 'Abrir configurações',
};
